import { request } from "./request";
import { phpRequest } from "@/apis/phpRequest";

export function getAnnouncementList(params) {
  return request.post("/announcement_list", params);
}

export function getTermList(params) {
  return request.post("/term_list", params);
}

export function getAnnouncementInfo(params) {
  return request.post("/announcement_info", params);
}

export function getTermInfo(params) {
  return request.post("/term_info", params);
}

export function deleteAnnouncement(id) {
  return request.post("/delete_announcement", { id });
}

export function deleteTerm(params) {
  return request.post("/delete_term", params);
}

export function createAnnouncement(params) {
  return request.post("/create_announcement", params);
}

export function createTerm(params) {
  return request.post("/create_term", params);
}

export function exportTerm(params) {
  return request.post("/export_term", params);
}

export function updateAnnouncement(params) {
  return request.post("/update_announcement", params);
}

export function downloadFileLink(path) {
  return phpRequest.get("/download-file-link", { path });
}

export const handleS3pathDownload = path => {
  downloadFileLink(path).then(fileRes => {
    window.open(fileRes.download_link);
  });
};

export function getNotificationListAPI(take, recordId, type) {
  return request.get("/notifications", {
    take,
    recordId,
    type
  });
}

export const updateNotificationAPI = notificationIdsArr => {
  return request.post("/notifications/update", {
    ids: notificationIdsArr
  });
};
